<template>
  <div>
    <v-container>
      <generalAlert
        v-if="alert"
        :alert="alert"
        :alertType="alertType"
        :message="successResponse"
      />
      <v-row>
        <v-col cols="12" sm="12" md="12" lg="12">
          <v-card v-if="!overlay" flat class="py-3 px-3">
            <v-card-text class="pt-0">
              <v-row justify="center" align="center">
                <v-col cols="6">
                  <h2 class="compeatfont">Demo Reports</h2>
                </v-col>
                <v-col cols="6"> </v-col>
              </v-row>
            </v-card-text>

            <v-card-title class="pt-0">
              <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                label="Search Clients"
                single-line
                hide-details
              ></v-text-field>
              <v-spacer></v-spacer>
              <demoReport
                @successAlert="successAlert"
                :salesPeople="salesPeople"
              />
            </v-card-title>
            <!-- {{ activeAcencies }} -->
            <v-data-table
              v-if="this.$store.state.user.resellerUid"
              :headers="headers"
              :items="demoResellerReports"
              :search="search"
              :items-per-page="10"
              :loading="overlay"
              loading-text="Loading... Please wait"
            >
              <template v-slot:[`item.action`]="{ item }">
                <v-btn @click="viewDemoReport(item)" icon color="primary"
                  ><v-icon>mdi-eye</v-icon></v-btn
                >
              </template>
            </v-data-table>

            <v-data-table
              v-else
              :headers="headers"
              :items="demoSubscriptions"
              :search="search"
              :items-per-page="10"
              :loading="overlay"
              loading-text="Loading... Please wait"
            >
              <template v-slot:[`item.action`]="{ item }">
                <v-btn @click="viewDemoReport(item)" icon color="primary"
                  ><v-icon>mdi-eye</v-icon></v-btn
                >
              </template>
            </v-data-table>
          </v-card>
          <v-skeleton-loader
            v-else
            height="372px"
            class="mx-auto"
            type="table-heading, table-thead, table-tbody, table-tfoot"
          >
          </v-skeleton-loader>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import generalAlert from "@/components/alerts/generalAlert.vue";
import demoReport from "@/components/dialogs/demoReport.vue";
const moment = require("moment-timezone");

import { firebaseApp } from "../firebaseConfig";
const db = getFirestore(firebaseApp);
import {
  collection,
  getDocs,
  getFirestore,
  query,
  where,
} from "firebase/firestore";
export default {
  components: {
    generalAlert,
    demoReport,
  },
  data: () => ({
    //Skeleton loading
    overlay: false,
    //Table Data and varibles
    demoSubscriptions: [],
    demoResellerReports: [],
    //For general alert on adding new user
    successResponse: "",
    alertType: "",
    alert: false,
    //Search field and data for table
    search: "",
    headers: [
      {
        text: "Client",
        value: "prospectingClientName",
        sortable: false,
        width: "10%",
        align: "center",
      },
      {
        text: "Company",
        sortable: false,
        value: "packagePages[0].name",
        width: "15%",
        align: "center",
      },
      {
        text: "Email",
        sortable: false,
        value: "prospectingClientEmail",
        width: "15%",
        align: "center",
      },
      {
        text: "Date Created",
        value: "createdAt",
        sortable: false,
        width: "10%",
        align: "center",
      },
      {
        text: "Action",
        value: "action",
        sortable: false,
        width: "10%",
        align: "center",
      },
    ],

    //sales people for demo report popup
    salesPeople: [],
  }),
  created() {
    this.getAllResellerDemoRports();
    // if (this.$store.state.user.resellerUid) {
    //   console.log("get demo reports");
    //   this.getAllResellerDemoRports();
    // } else {
    //   this.getAllDemoSubscriptions();
    // }
  },
  methods: {
    //Gets all users and filters it out on userType
    // async getAllDemoSubscriptions() {
    //   this.overlay = true;
    //   this.demoSubscriptions = [];
    //   try {
    //     const querySnapshot = await getDocs(collection(db, "demoreports"));
    //     querySnapshot.forEach((doc) => {
    //       let report = doc.data();

    //       let createdMilliseconds = report.createdAt;
    //       let formatCreatedDate =
    //         moment(createdMilliseconds).format("YYYY-MM-DD h:mm a");
    //       report.createdAt = formatCreatedDate;

    //       if (
    //         (report.agencyId === this.$store.state.agency.agencyId &&
    //           this.$store.state.user.userType == "AA") ||
    //         (report.agencyId === this.$store.state.agency.agencyId &&
    //           this.$store.state.user.userType == "SMM")
    //       ) {
    //         this.demoSubscriptions.push(report);
    //       } else if (this.$store.state.user.userType == "SA") {
    //         this.demoSubscriptions.push(report);
    //       }
    //     });

    //     // Sort the array by date
    //     this.demoSubscriptions.sort((a, b) => {
    //       return new Date(b.createdAt) - new Date(a.createdAt);
    //     });

    //     this.getAgencySalesPeople();
    //   } catch (error) {
    //     console.log(error);
    //   }
    // },
    //Get all resellers demo reports
    async getAllResellerDemoRports() {
      this.overlay = true;
      this.demoResellerReports = [];
      const q = query(
        collection(db, "demoreports"),
        where("agencyId", "==", this.$store.state.user.agencyId),
        where("salesPerson", "==", this.$store.state.user.id) // Add another where clause as needed
      );

      const querySnapshot = await getDocs(q);
      querySnapshot.forEach((doc) => {
        let demoReport = doc.data();

        let createdMilliseconds = demoReport.createdAt;
        let formatCreatedDate =
          moment(createdMilliseconds).format("YYYY-MM-DD h:mm a");
        demoReport.createdAt = formatCreatedDate;

        this.demoResellerReports.push(demoReport);
      });

      // Sort the array by date
      this.demoResellerReports.sort((a, b) => {
        return new Date(b.createdAt) - new Date(a.createdAt);
      });

      this.overlay = false;
    },
    //Get all agency sales users
    async getAgencySalesPeople() {
      try {
        const querySnapshot = await getDocs(collection(db, "users"));
        querySnapshot.forEach((doc) => {
          // doc.data() is never undefined for query doc snapshots
          let user = doc.data();

          if (
            user.agencyId == this.$store.state.agency.agencyId &&
            user.userType == "AS"
          ) {
            this.salesPeople.push(user);
          }
          this.overlay = false;
        });
      } catch (err) {
        console.log("getAgencySalesPeople err", err);
      }
    },
    //Alert functions to display response from adding new user
    successAlert(message, typeOfAlert) {
      this.successResponse = message;
      this.alertType = typeOfAlert;
      this.alert = true;

      setTimeout(() => {
        this.getAllDemoSubscriptions();
        this.alert = false;
      }, 3000);
    },
    //View the demo report
    viewDemoReport(item) {
      this.$router.push({
        name: "demoReport",
        params: {
          reportId: item.reportId,
        },
      });
    },
  },
};
</script>
